function showPrice() {
  let t = $(
    ".t4s-product__info-wrapper .t4s-product__price-review .t4s-product-price"
  ).text();
  $(
    ".t4s-product__info-container .t4s-product__price-review .t4s-product-price ins"
  ).length > 0 &&
    (t = $(
      ".t4s-product__info-wrapper .t4s-product__price-review .t4s-product-price ins"
    ).text()),
    $(".main-product-title-box .only-current-price").text(t);
}
$("body").on("click", ".product-variant-title-box", function () {
  console.log("2222"), $(this).toggleClass("hide-box");
}),
  $(document).ready(function () {
    $("[data-collage-toggle]").on("click", function () {
      let t = $(this).closest("[data-collage-item]");
      t.hasClass("open") ||
        $("[data-collage-item]")
          .removeClass("open")
          .find(".collage-content")
          .slideUp(200),
        t.toggleClass("open"),
        t.find(".collage-content").slideToggle(200);
    });
  });
let showMediaStatus = !1;
function filterMediaShow(t) {
  let o = 0;
  t || showMediaStatus
    ? (console.log("quanbushifang"),
      $(".t4s-product__media-item").removeClass("showMoreHide"))
    : $(".t4s-product__media-item").each(function () {
        !$(this).hasClass("is--media-hide") &&
          (console.log($(this)), ++o > 4 && $(this).addClass("showMoreHide"));
      });
}
$(document).ready(function () {
  filterMediaShow(!1);
}),
 
  $(window).on("scroll", function () {
    $(".about-us-text-bg-image-box .common-box-container").each(function () {
      var t = $(window).scrollTop(),
        o = $(this).offset().top,
        e = $(this).outerHeight(),
        i = o - e;
      if (t + $(window).height() > o && t < o + e) {
        var s = -((t - i) * 0.12);
        767 > $(window).width() && (s = -((t - i) * 0.04)),
          $(this).css("background-position", "center " + s + "px");
      }
    });
  });
